import React from 'react';

import { API } from 'constants';
import client from '../../../services/template-api';

import useCustomPagination from '../../../hooks/useCustomPagination';
import { useSaveInContextRequestKeysWithMultipleAccessors } from '../../../hooks/useSaveInContextRequestKeysWithMultipleAccessors';

import { TEMPLATES_LIBRARY_TABS } from '../../../constants/template';

import { getTemplatesLibraryRequestQueryParams } from '../../../helpers/getTemplatesLibraryRequestQueryParams';

import Loading from '../../../components/Loading';
import PaginatedContainer from '../../../components/PaginatedContainer/PaginatedContainer';
import TemplatesLibraryIndexPage from '../TemplatesLibraryIndexPage/TemplatesLibraryIndexPage';

const getDataRequestRoute = {
    [TEMPLATES_LIBRARY_TABS.goals]: API.ROUTES.template.goalTemplate,
    [TEMPLATES_LIBRARY_TABS.processes]: API.ROUTES.template.processTemplate,
    [TEMPLATES_LIBRARY_TABS.playbooks]: API.ROUTES.template.playbookTemplate,
};

export const contextAccessor = {
    [TEMPLATES_LIBRARY_TABS.goals]: 'goalTemplates',
    [TEMPLATES_LIBRARY_TABS.processes]: 'processTemplates',
    [TEMPLATES_LIBRARY_TABS.playbooks]: 'playbookTemplates',
};

const TemplatesLibraryPaginatedContainer = ({ parsedParams, activeTab }) => {
    const searchParams = getTemplatesLibraryRequestQueryParams(parsedParams);

    const { data, total, count, loading, key, nextPageKey } = useCustomPagination({
        pageIndex: parsedParams.page - 1 || 0,
        searchParams,
        client: client,
        route: getDataRequestRoute[activeTab],
        autoFetchNextPage: true,
    });

    const requestKeysToMutate = useSaveInContextRequestKeysWithMultipleAccessors({
        key,
        nextPageKey,
        allPageAccessors: ['goalTemplates', 'processTemplates', 'playbookTemplates'],
        pageAccessor: contextAccessor[activeTab],
    });

    if (loading) {
        return <Loading />;
    }

    const page = Number(parsedParams.page) || 1;

    return (
        <PaginatedContainer page={page} total={total} count={count}>
            <TemplatesLibraryIndexPage
                data={data}
                activeTab={activeTab}
                loading={loading}
                page={page}
                parsedParams={parsedParams}
                requestKeysToMutate={requestKeysToMutate}
            />
        </PaginatedContainer>
    );
};

export default TemplatesLibraryPaginatedContainer;
